<template>
  <div v-if="message || (value && value.length > 0)">
    <div class="myalert">
      <div class="alert" :class="typeClass">
        <template v-for="(m, index) in messages">
          <p :key="index" class="mb-2">
            <small>{{ $t(m) }}</small>
          </p>
        </template>
        <a class="close" @click="reset"><close></close></a>
      </div>
    </div>
  </div>
</template>
<script>
import Close from '@/components/Icons/Close.vue'
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    Close
  },
  computed: {
    ...mapGetters({
      message: 'alert/message',
      value: 'alert/value',
      type: 'alert/type',
      authLocale: 'auth/locale'
    }),
    typeClass () {
      let ret = `alert-${this.type}`
      if (this.top) {
        ret += ' top'
      }
      return ret
    },
    messages () {
      const messages = []
      if (this.value && this.value.length > 0) {
        for (const v of this.value) {
          messages.push(`${this.$t(v.path)} ${v.message[this.authLocale]}`)
        }
      } else {
        messages.push(this.message)
      }
      return messages
    }
  },
  updated () {
    this.$nextTick(() => {
      setTimeout(() => {
        this.reset()
      }, 5000)
    })
  },
  methods: {
    ...mapMutations({
      reset: 'alert/reset'
    })
  }
}
</script>
<style lang="scss">
.myalert {
  position: absolute;
  top: 5em;
  right: 0px;
  max-width: 90%;
  z-index: 9999;
  .alert {
    padding-right: 2em;
    .close {
      position: absolute;
      top: 10px;
      right: -15px;
      svg {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 1em;
        cursor: pointer;
      }
    }

  }
}
</style>
<i18n>
{
  "ka": {
    "bad gender": "მიუთითე სქესი",
    "firstname,ka": "სახელი",
    "lastname,ka": "გვარი",
    "personal_number": "პირადი ნომერი",
    "phone_number": "ტელეფონი",
    "password": "პაროლი",
    "repeat_password": "გაიმეორე პაროლი"
  },
  "en": {
    "bad gender": "Bad gender value",
    "firstname,en": "First Name",
    "lastname,en": "Last Name",
    "personal_number": "ID",
    "phone_number": "Phone",
    "password": "Password",
    "repeat_password": "Confirm Password"
  }
}
</i18n>
